import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { radiologyQKeys } from "@hooks/queries/radiology/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";


interface MutationProps {
  radId: string;
  patientId: string;
}

export const useDeleteRadiology = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ radId }: MutationProps) => {
      return api.delete(`radiology/${radId}`);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: radiologyQKeys.patient(variables.patientId),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Radiology]", res);
    },
  });
};
